// import moment from 'moment';
const mixin = {
  computed: {
    btnDisabled() {
      return !(this.form.energyType != null && this.form.energyType != '');
    },
    formColumn() {
      let arr = [
        {
          prop: 'energyType',
          type: 'select',
          name: '能耗表类型',
          options: [
            { label: '电表', value: '02' },
            { label: '水表', value: '01' },
          ],
          changeMethod: this.changeEnergyType,
          clearable: false,
          filterable: false,
          span: 24,
        },
      ];
      if (this.form.energyType != '' && this.form.energyType != null) {
        arr.push(
          {
            prop: 'companyCode',
            name: '公司',
            type: 'select',
            span: 24,
            value: 'personCompanyCode',
            label: 'personCompanyName',
            options: this.companyList,
            changeMethod: this.resetMeterNo,
            clearable: false,
            disabled: true,
            filterable: false,
            placeholder: '全部',
          },
          {
            prop: 'spaceAreaId',
            name: '片区：',
            type: 'select',
            span: 24,
            value: 'id',
            label: 'name',
            options: this.spaceAreaList,
            disabled: this.spaceAreaDisabled,
            changeMethod: this.resetMeterNo,
            placeholder: '全部片区',
            filterable: false,
          },
          {
            prop: 'spaceAssetId',
            name: '物业：',
            type: 'select',
            span: 24,
            value: 'id',
            label: 'name',
            options: this.spaceAssetList,
            disabled: this.spaceAssetDisabled,
            changeMethod: this.resetMeterNo,
            placeholder: '全部物业',
            filterable: false,
          },

          {
            prop: 'spaceUnitId',
            name: '单元：',
            type: 'select',
            span: 24,
            value: 'id',
            label: 'name',
            options: this.spaceUnitList,
            disabled: this.spaceUnitDisabled,
            changeMethod: this.resetMeterNo,
            placeholder: '全部单元',
            filterable: false,
          },
          {
            prop: 'spaceFloorId',
            name: '楼层：',
            type: 'select',
            span: 24,
            value: 'id',
            label: 'name',
            options: this.spaceFloorList,
            disabled: this.spaceFloorDisabled,
            changeMethod: this.resetMeterNo,
            placeholder: '全部楼层',
            filterable: false,
          },
          {
            prop: 'spaceId',
            name: '房号：',
            type: 'select',
            span: 24,
            value: 'id',
            label: 'name',
            options: this.spaceList,
            disabled: this.spaceDisabled,
            changeMethod: this.resetMeterNo,
            placeholder: '全部房号',
            filterable: false,
          }
        );
        if (this.form.energyType == '01') {
          arr.push(
            {
              prop: 'waterMeterNo',
              type: 'select',
              name: '水表编号：',
              options: this.meterList,
              value: 'id',
              label: 'meterNo',
              span: 24,
            },
            {
              prop: 'waterMeterType',
              name: '水表类型：',
              type: 'select',
              span: 24,
              placeholder: '请输入内容',
              filterable: false,
              options: this.$baseRequest.getDictListMapByType('water_meter_type'),
              disabled: true,
            }
          );
        } else if (this.form.energyType == '02') {
          arr.push(
            {
              prop: 'electricMeterNo',
              type: 'select',
              name: '电表编号：',
              options: this.meterList,
              value: 'id',
              label: 'meterNo',
              clearable: false,
              span: 24,
            },
            {
              prop: 'electricMeterType',
              name: '电表类型：',
              type: 'select',
              span: 24,
              placeholder: '请输入内容',
              options: this.$baseRequest.getDictListMapByType('meter_type'),
              disabled: true,
              filterable: false,
            }
          );
        }
        arr.push(
          {
            prop: 'readMeterMonthStart',
            name: '抄表期间从：',
            type: 'startDaterangePicker',
            // format: 'yyyy-MM',
            // forecastMonth: false,
            disabled: false,
            editable: false,
            span: 24,
            placeholder: '无',
          },
          {
            prop: 'readMeterMonthEnd',
            name: '抄表期间至：',
            type: 'endDaterangePicker',
            disabled: false,
            editable: false,
            span: 24,
            placeholder: '无',
          }
        );
        if (this.form.energyType == '01') {
          arr.push({
            prop: 'waterPriceMonth',
            name: '水价月份：',
            type: 'month',
            format: 'yyyy-MM',
            forecastMonth: false,
            editable: false,
            disabled: false,
            span: 24,
            placeholder: '无',
          });
        } else if (this.form.energyType == '02') {
          arr.push({
            prop: 'electricPriceMonth',
            name: '电价月份：',
            type: 'month',
            editable: false,
            format: 'yyyy-MM',
            forecastMonth: false,
            disabled: false,
            span: 24,
            placeholder: '无',
          });
        }
        arr.push(
          {
            prop: 'accountPeriod',
            name: '业务账期：',
            type: 'month',
            format: 'yyyy-MM',
            forecastMonth: false,
            editable: false,
            disabled: false,
            span: 24,
            placeholder: '无',
          },

          {
            prop: 'customerName',
            name: '客户名称：',
            type: 'input',
            span: 24,
            disabled: true,
            placeholder: '',
          }
        );
        if (this.form.energyType == '01') {
          arr.push(
            {
              prop: 'periodStartRead',
              name: '期初水表读数：',
              type: 'inputAmount',
              max: 999999999,
              span: 24,
              placeholder: '无',
            },
            {
              prop: 'periodEndRead',
              name: '期末水表读数：',
              type: 'inputAmount',
              max: 999999999,
              span: 24,
              placeholder: '无',
            }
          );
        } else {
          arr.push(
            {
              prop: 'periodStartRead',
              name: '期初电表读数：',
              max: 999999999,
              type: 'inputAmount',
              span: 24,
              placeholder: '无',
            },
            {
              prop: 'periodEndRead',
              name: '期末电表读数：',
              type: 'inputAmount',
              max: 999999999,
              span: 24,
              placeholder: '无',
            }
          );
        }
        arr.push(
          {
            prop: 'currentMonthRead',
            name: '当月读数：',
            type: 'inputAmount',
            max: 999999999,
            placeholder: '无',
            span: 24,
            disabled: true,
          },
          {
            prop: 'readMeterDate',
            name: '抄表日期：',
            type: 'date',
            span: 24,
            placeholder: '无',
            disabled: true,
          },
          {
            prop: 'remark',
            name: '备注：',
            type: 'input',
            span: 24,
            placeholder: '无',
          }
        );
      }

      return arr;
    },
  },
  watch: {
    'form.waterMeterNo': {
      handler(newVal, oldVal) {
        console.log('newVal', newVal, 'oldVal', oldVal);
        if (newVal != oldVal && newVal != '') {
          this.form.customerName = ''; //客户名称
          this.form.waterMeterType = ''; //水表类型
          this.form.readMeterMonthStart = '';
          this.form.readMeterMonthEnd = '';
          this.form.periodStartRead = '';
          this.form.periodEndRead = '';
          this.form.floorMeterNo = '';
          this.form.floorMeterName = '';
          this.form.unitMeterNo = '';
          this.form.unitMeterName = '';
          this.form.masterMeterNo = '';
          this.form.masterSpaceName = '';
          this.form.currentMonthRead = '';
          this.getWaterDetail(newVal);
          this.getWaterReadDetail(newVal);
        } else {
          if (!this.removeMeterNo) {
            this.spaceAssetDisabled = true;
            this.spaceUnitDisabled = true;
            this.spaceFloorDisabled = true;
            this.spaceDisabled = true;
            this.form.spaceAreaId = '';
            this.form.spaceAssetId = '';
            this.form.spaceUnitId = '';
            this.form.spaceFloorId = '';
            this.form.spaceId = '';
            this.spaceAssetList = [];
            this.spaceUnitList = [];
            this.spaceFloorList = [];
            this.spaceList = [];
            this.removeMeterNo = false;
          }
          if (this.form.energyType == '01') {
            this.form.floorMeterNo = '';
            this.form.floorMeterName = '';
            this.form.unitMeterNo = '';
            this.form.unitMeterName = '';
            this.form.masterMeterNo = '';
            this.form.masterSpaceName = '';
            this.form.customerName = ''; //客户名称
            this.form.waterMeterType = ''; //水表类型
            this.form.readMeterMonthStart = '';
            this.form.readMeterMonthEnd = '';
            this.form.periodStartRead = '';
            this.form.periodEndRead = '';
            this.form.currentMonthRead = '';
            this.form.remark = '';
            this.meterList = this.allMeterList;
          }
        }
      },
    },
    'form.electricMeterNo': {
      handler(newVal, oldVal) {
        console.log('电表编号改变了', newVal);
        if (newVal != oldVal && newVal != '') {
          this.form.customerName = ''; //客户名称
          this.form.electricMeterType = ''; //电表类型
          this.form.loss = ''; //损耗
          this.form.inductanceRatio = ''; //电感比/倍率
          this.form.transformer = '';
          this.form.readMeterMonthStart = '';
          this.form.readMeterMonthEnd = '';
          this.form.periodStartRead = '';
          this.form.periodEndRead = '';
          this.form.currentMonthRead = '';
          this.unchangeMeterNo = true;
          this.getElectricDetail(newVal);
          this.getElectricReadDetail(newVal);
        } else {
          if (!this.removeMeterNo) {
            this.spaceAssetDisabled = true;
            this.spaceUnitDisabled = true;
            this.spaceFloorDisabled = true;
            this.spaceDisabled = true;
            this.form.spaceAreaId = '';
            this.form.spaceAssetId = '';
            this.form.spaceUnitId = '';
            this.form.spaceFloorId = '';
            this.form.spaceId = '';
            this.spaceAssetList = [];
            this.spaceUnitList = [];
            this.spaceFloorList = [];
            this.spaceList = [];
            this.removeMeterNo = false;
          }
          if (this.form.energyType == '02') {
            this.form.customerName = ''; //客户名称
            this.form.electricMeterType = ''; //电表类型
            this.form.loss = ''; //损耗
            this.form.inductanceRatio = ''; //电感比/倍率
            this.form.readMeterMonthStart = '';
            this.form.readMeterMonthEnd = '';
            this.form.periodStartRead = '';
            this.form.periodEndRead = '';
            this.form.currentMonthRead = '';
            this.form.remark = '';
            this.meterList = this.allMeterList;
          }
        }
      },
    },
    'form.companyCode': {
      handler: function (newVal) {
        if (this.removeSpace) {
          this.form.spaceAreaId = '';
          this.form.spaceAssetId = '';
          this.form.spaceUnitId = '';
          this.form.spaceFloorId = '';
          this.form.spaceId = '';
          this.removeSpace = false;
        }
        if (newVal != '') {
          this.spaceAreaDisabled = false;
          this.getArea('0', 'area');
        } else {
          this.spaceAreaDisabled = true;
          this.spaceAssetDisabled = true;
          this.spaceUnitDisabled = true;
          this.spaceFloorDisabled = true;
          this.spaceDisabled = true;

          this.spaceAreaList = [];
          this.spaceAssetList = [];
          this.spaceUnitList = [];
          this.spaceFloorList = [];
          this.spaceList = [];
          this.meterList = this.allMeterList;
        }
      },
    },
    'form.spaceAreaId': {
      handler: function (newVal) {
        if (this.removeSpace) {
          this.form.spaceAssetId = '';
          this.form.spaceUnitId = '';
          this.form.spaceFloorId = '';
          this.form.spaceId = '';
          this.removeSpace = false;
        }
        if (newVal != '') {
          this.spaceAssetDisabled = false;
          this.getArea(newVal, 'asset');
          this.meterList = this.allMeterList;
        } else {
          // 片区改变，水表回归最初列表
          this.meterList = this.allMeterList;
          this.spaceAssetDisabled = true;
          this.spaceUnitDisabled = true;
          this.spaceFloorDisabled = true;
          this.spaceDisabled = true;
          this.spaceAssetList = [];
          this.spaceUnitList = [];
          this.spaceFloorList = [];
          this.spaceList = [];
        }
      },
    },
    'form.spaceAssetId': {
      handler: function (newVal) {
        if (this.removeSpace) {
          this.form.spaceUnitId = '';
          this.form.spaceFloorId = '';
          this.form.spaceId = '';
          this.removeSpace = false;
        }
        if (newVal != '') {
          this.spaceUnitDisabled = false;
          this.getArea(newVal, 'unit');
          if (this.spaceAssetList.length > 0) {
            let index = this.spaceAssetList.findIndex((item) => item.id == newVal);
            if (index != -1) {
              if (this.spaceAssetList[index].leafFlag == 0) {
                this.findSpaceByMeterNo({ spaceId: newVal });
              } else {
                this.meterList = this.allMeterList;
              }
            }
          }
        } else {
          this.spaceUnitDisabled = true;
          this.spaceFloorDisabled = true;
          this.spaceDisabled = true;
          this.spaceUnitList = [];
          this.spaceFloorList = [];
          this.spaceList = [];
        }
      },
    },
    'form.spaceUnitId': {
      handler: function (newVal) {
        if (this.removeSpace) {
          this.form.spaceFloorId = '';
          this.form.spaceId = '';
          this.removeSpace = false;
        }
        if (newVal != '') {
          this.spaceFloorDisabled = false;
          this.getArea(newVal, 'floor');
          if (this.spaceUnitList.length > 0) {
            let index = this.spaceUnitList.findIndex((item) => item.id == newVal);
            if (index != -1) {
              if (this.spaceUnitList[index].leafFlag == 0) {
                this.findSpaceByMeterNo({ spaceId: newVal });
              } else {
                this.meterList = this.allMeterList;
              }
            }
          }
        } else {
          this.spaceFloorDisabled = true;
          this.spaceDisabled = true;
          this.spaceFloorList = [];
          this.spaceList = [];
        }
      },
    },
    'form.spaceFloorId': {
      handler: function (newVal) {
        if (this.removeSpace) {
          this.form.spaceId = '';
          this.removeSpace = false;
        }
        if (newVal != '') {
          this.spaceDisabled = false;
          this.getArea(newVal, 'space');
          if (this.spaceFloorList.length > 0) {
            let index = this.spaceFloorList.findIndex((item) => item.id == newVal);
            if (index != -1) {
              if (this.spaceFloorList[index].leafFlag == 0) {
                this.findSpaceByMeterNo({ spaceId: newVal });
              } else {
                this.meterList = this.allMeterList;
              }
            }
          }
        } else {
          this.spaceDisabled = true;
          this.spaceList = [];
        }
      },
    },
    'form.spaceId': {
      handler: function (newVal) {
        if (newVal != '') {
          this.findSpaceByMeterNo({ spaceId: newVal });
        }
      },
    },
    'form.periodEndRead': {
      handler: function (newVal) {
        if (newVal != '') {
          if (this.form.periodStartRead != '') {
            this.form.currentMonthRead =
              '' + (this.form.periodEndRead - this.form.periodStartRead).toFixed(2);
          } else {
            this.form.currentMonthRead = '' + this.form.periodEndRead.toFixed(2);
          }
        } else {
          this.form.currentMonthRead = '';
        }
      },
    },
    'form.periodStartRead': {
      handler: function (newVal) {
        if (newVal != '') {
          if (this.form.periodEndRead != '') {
            this.form.currentMonthRead =
              '' + (this.form.periodEndRead - this.form.periodStartRead).toFixed(2);
          } else {
            this.form.currentMonthRead = '';
          }
        } else {
          this.form.currentMonthRead = '';
        }
        // if
      },
    },
  },
};
export default mixin;
